
//Color Pallet: #84c1ff • #add6ff • #d6eaff • #eaf4ff • #f8fbff
export const HEADER_BACKGROUND_COLOR = "#add6ff"
export const BANNER_BACKGROUND_COLOR = "#eaf4ff"
export const BACKGROUND_COLOR = "#f8fbff"
